import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Calendar } from "lucide-react";
import { getMonthPortal } from "../../api/academicCalendarPortalApi";
import { getMonth } from "../../api/academicCalendarApi";
import WidgetCard from "../widget/WidgetCard";

export const AcademicCalendarWidget = ({ isPortal = false }) => {
  const navigate = useNavigate();
  const [calendarData, setCalendarData] = useState(null);
  const [loading, setLoading] = useState(true);

  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const res = isPortal ? await getMonthPortal(year, month) : await getMonth(year, month);
        if (!cancelled) {
          setCalendarData(res);
        }
      } catch (err) {
        console.error("Failed to load academic calendar widget", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isPortal, year, month]);

  const basePath = isPortal ? "/staff-panel/academic-calendar" : "/academic-calendar";

  return (
    <WidgetCard
      title="Academic Calendar Summary"
      icon={Calendar}
      loading={loading}
      empty={!loading && !calendarData}
      emptyText="No calendar data available."
      onViewAll={() => navigate(basePath)}
    >
      {calendarData && (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-center">
          {/* Working Days */}
          <div className="rounded-xl border border-slate-200/80 bg-neutral-50 dark:bg-neutral-900/80 p-3 transition-all hover:bg-slate-100/60">
            <p className="text-[11px] font-bold uppercase tracking-wider text-slate-500 dark:text-neutral-400">
              Working Days
            </p>
            <p className="mt-1 text-2xl font-extrabold text-slate-900 dark:text-neutral-100 leading-none">
              {calendarData.working}
            </p>
          </div>

          {/* Holidays */}
          <div className="rounded-xl border border-rose-200/80 bg-rose-50/80 p-3 transition-all hover:bg-rose-100/60">
            <p className="text-[11px] font-bold uppercase tracking-wider text-rose-600">
              Holidays
            </p>
            <p className="mt-1 text-2xl font-extrabold text-rose-900 leading-none">
              {calendarData.holidays}
            </p>
          </div>

          {/* Half Days */}
          <div className="rounded-xl border border-amber-200/80 bg-amber-50/80 p-3 transition-all hover:bg-amber-100/60">
            <p className="text-[11px] font-bold uppercase tracking-wider text-amber-600">
              Half Days
            </p>
            <p className="mt-1 text-2xl font-extrabold text-amber-900 leading-none">
              {calendarData.halfDays || 0}
            </p>
          </div>
        </div>
      )}
    </WidgetCard>
  );
};